'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var jsxRuntime = require('react/jsx-runtime');
var moneyAmount = require('@andes/money-amount');
const getFormattedIntFraction = (price, separator) => {
  const rawFraction = Math.floor(price).toString();
  return rawFraction.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, n => `${n}${separator}`);
};
const isDecimalNone = decimal_style => {
  if (decimal_style === 'none') return true;
  return false;
};
const isDecimalZero = decimalPart => decimalPart === '00';
const getFormattedDecimalFraction = (price, decimal_style) => {
  const fixedStr = price.toFixed(2);
  const decimalPart = fixedStr.split('.')[1];
  if (!isDecimalZero(decimalPart) && !isDecimalNone(decimal_style)) {
    return decimalPart;
  }
  return '';
};
const getAmount = (value, currency, decimal_style, thousandSeparator) => {
  const currencyId = currency;
  const fraction = getFormattedIntFraction(value, thousandSeparator);
  const cents = getFormattedDecimalFraction(value, decimal_style);
  return {
    currencyId,
    fraction,
    cents
  };
};
const mapDecimalSymbol = {
  ',': 'comma',
  '.': 'dot'
};
const PriceAmount = _ref => {
  let {
    value,
    currency,
    thousandSeparator,
    decimalSeparator,
    decimal_style = 'normal',
    size,
    previous = false,
    className = '',
    centsType,
    compact = false,
    suffix,
    symbol
  } = _ref;
  if (!value || !thousandSeparator || !currency) return null;
  const amount = getAmount(value, currency, decimal_style, thousandSeparator);
  const centsTypeMoney = centsType != null ? centsType : decimalSeparator && mapDecimalSymbol[decimalSeparator];
  return jsxRuntime.jsx(moneyAmount.MoneyAmount, {
    size: size,
    currencyId: currency,
    value: amount,
    previous: previous,
    className: className,
    centsType: centsTypeMoney,
    compact: compact,
    suffix: suffix,
    symbol: symbol
  });
};
exports.PriceAmount = PriceAmount;
